import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { TileStyle } from 'stylecomponents';
import CupoySrefView from 'components/commons/router/CupoySrefView';


class Tile extends React.PureComponent {

  renderByType = (type, text, fontSize, isHot) => {
    switch (type) {
      case 'profitEvent':
        return (
          <TileStyle.TextWrapper>
            <TileStyle.Text fontSize={fontSize}>{text}</TileStyle.Text>
          </TileStyle.TextWrapper>
        )
      case 'smallBlock':
        return (
          <TileStyle.TextWrapper smallpadding>
            <TileStyle.Text fontSize={fontSize} >{text}</TileStyle.Text>
          </TileStyle.TextWrapper>
        )
      case 'BONUS_PRRDUCT':
        return (
          <React.Fragment>
            {isHot && <TileStyle.HotTag>HOT</TileStyle.HotTag>}
            <TileStyle.TextWrapper column paddingTop>
              <TileStyle.Text bold>{text}</TileStyle.Text>
              <TileStyle.ClickButton>立即兌換</TileStyle.ClickButton>
            </TileStyle.TextWrapper>
          </React.Fragment>
        )
      case 'FREE_PRRDUCT':
        return (
          <React.Fragment>
            {isHot && <TileStyle.HotTag>HOT</TileStyle.HotTag>}
            <TileStyle.TextWrapper column paddingTop>
              <TileStyle.Text bold>{text}</TileStyle.Text>
              <TileStyle.ClickButton>立即索取</TileStyle.ClickButton>
            </TileStyle.TextWrapper>
          </React.Fragment>
        )
      case 'VITEM_PRRDUCT':
        return (
          <React.Fragment>
            {isHot && <TileStyle.HotTag>HOT</TileStyle.HotTag>}
            <TileStyle.Wrapper column>
              <TileStyle.Row>
                <TileStyle.Text bold>{text}</TileStyle.Text>
                <TileStyle.Text bold highlight>47元</TileStyle.Text>
              </TileStyle.Row>
              <TileStyle.Row>
                <TileStyle.ClickButton>立即索取</TileStyle.ClickButton>
                <TileStyle.CartButton>
                  <TileStyle.Icon className="zmdi zmdi-shopping-cart" />
                  加到購物車
                </TileStyle.CartButton>
              </TileStyle.Row>
            </TileStyle.Wrapper>
          </React.Fragment>
        )
      case 'POINT_CARD':
        return (
          <React.Fragment>
            {isHot && <TileStyle.HotTag>HOT</TileStyle.HotTag>}
            <TileStyle.Wrapper column>
              <TileStyle.Row>
                <TileStyle.Text bold>{text}</TileStyle.Text>
                <TileStyle.Text bold highlight>47元</TileStyle.Text>
              </TileStyle.Row>
              <TileStyle.Row>
                <TileStyle.ClickButton>立即購買</TileStyle.ClickButton>
                <TileStyle.CartButton>
                  <TileStyle.Icon className="zmdi zmdi-shopping-cart" />
                  加到購物車
                </TileStyle.CartButton>
              </TileStyle.Row>
            </TileStyle.Wrapper>
          </React.Fragment>
        )
      default:
        return (
          <TileStyle.Text fontSize={fontSize} >{text}</TileStyle.Text>
        )
    }
  }

  clickCallback = () => {

    const {
      clickCallback,
      callbackParams,
    } = this.props;

    clickCallback && clickCallback(callbackParams);
  }

  render() {
    
    const {
      tileWidth,
      tileHeight,
      imgWidth,
      imgHeight,
      fontSize,
      type,
      noMarginBottom,
      display,
      margin,
    } = this.props.tileStyle;

    const {
      text,
      img,
      isHot,
      detailState,
      id,
      clickCallback,
    } = this.props;

    return (
      clickCallback ?
      <TileStyle.Container
        width={tileWidth}
        height={tileHeight}
        marginValue={margin}
        margin={type === 'sideBlock' || type === 'smallBlock'}
        border={type === 'sideBlock' || type === 'smallBlock'}
        noMarginBottom={noMarginBottom}
        onClick={this.clickCallback}
        display={display}
      >
        <TileStyle.TileImg img={img} width={imgWidth} height={imgHeight} />
        {this.renderByType(type, text, fontSize, isHot)}
      </TileStyle.Container>
      :
      <CupoySrefView
        statename={detailState}
        params={{ id }}
      >
        <TileStyle.Container
          width={tileWidth}
          height={tileHeight}
          marginValue={margin}
          margin={type === 'sideBlock' || type === 'smallBlock'}
          border={type === 'sideBlock' || type === 'smallBlock'}
          noMarginBottom={noMarginBottom}
        >
          <TileStyle.TileImg img={img} width={imgWidth} height={imgHeight} />
          {this.renderByType(type, text, fontSize, isHot)}
        </TileStyle.Container>
      </CupoySrefView>
    )
  }
}

const mapStateToProps = function (state) {
  return {
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
  };
};

/*--------------------------
  Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(Tile);